import { render } from "./DeleteReasonModal.vue?vue&type=template&id=16572d5d&ts=true"
import script from "./DeleteReasonModal.vue?vue&type=script&lang=ts"
export * from "./DeleteReasonModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__